export default {
  name: "Bucks",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M28 27H4c-1.16 0-2-.84-2-2V7c0-1.16.84-2 2-2h24c1.16 0 2 .84 2 2v18c0 1.16-.84 2-2 2zM4 7v18h24.05L28 7H4zm16.98 12.42a5.73 5.73 0 0 0 .97-4.15h-6.64v2.32h3.32a2.93 2.93 0 0 1-4.76.6 3.16 3.16 0 0 1-.92-2.31c0-.83.3-1.54.9-2.13.6-.59 1.32-.89 2.16-.89.89 0 1.68.38 2.4 1.13h3.27a6.18 6.18 0 0 0-2.23-2.92 5.81 5.81 0 0 0-3.4-1.07c-1.68 0-3.1.57-4.27 1.71A5.55 5.55 0 0 0 10 15.88 5.96 5.96 0 0 0 16 22a6 6 0 0 0 4.98-2.58z",
  },
}
